<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import CompetitorRankingBlock from "@/components/keyword/partials/CompetitorRankingBlock.vue";

const store = useStore();

const competitorRanking = computed(() => store.getters['untrackedKeywords/competitorRanking']);
const adjustments = computed(() => store.getters['untrackedKeywords/adjustments']);

const rankings = computed(() => {
  return {
    top_3: competitorRanking.value.top_3 - adjustments.value.top_3,
    top_3_change: competitorRanking.value.top_3_change
      ? competitorRanking.value.top_3_change - adjustments.value.top_3_change
      : null,
    page_1: competitorRanking.value.page_1 - adjustments.value.page_1,
    page_1_change: competitorRanking.value.page_1_change
      ? competitorRanking.value.page_1_change - adjustments.value.page_1_change
      : null,
    page_2: competitorRanking.value.page_2 - adjustments.value.page_2,
    page_2_change: competitorRanking.value.page_2_change
      ? competitorRanking.value.page_2_change - adjustments.value.page_2_change
      : null,
    total_keywords: competitorRanking.value.total_keywords - adjustments.value.total_keywords,
    total_keywords_change: competitorRanking.value.total_keywords_change
      ? competitorRanking.value.total_keywords_change - adjustments.value.total_keywords_change
      : null,
  }
})
</script>

<template>
  <div
    v-if="competitorRanking"
    class="-tw-mx-8 tw-border-b tw-border-grey-mid tw-pb-8"
  >
    <div class="tw-flex tw-space-x-8 tw-items-center tw-justify-center tw-px-8">
      <CompetitorRankingBlock
        :value="rankings.top_3"
        :value-change="rankings.top_3_change"
        tooltip-text="Total number of keywords that we have found within the first 3 positions on Google."
        text="Top 3 Positions"
      />

      <CompetitorRankingBlock
        :value="rankings.page_1"
        :value-change="rankings.page_1_change"
        tooltip-text="Total number of keywords that we have found on the first page of Google, this includes keywords in the top 3 positions."
        text="Page 1"
      />

      <CompetitorRankingBlock
        :value="rankings.page_2"
        :value-change="rankings.page_2_change"
        tooltip-text="Total number of keywords that we have found on the second page of Google."
        text="Page 2"
      />

      <CompetitorRankingBlock
        :value="rankings.total_keywords"
        :value-change="rankings.total_keywords_change"
        tooltip-text="Total number of keywords that we have in our index for the given domain name."
        text="Total Keywords"
      />
    </div>
  </div>
</template>

